import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);

const btns = () => {
  let color = `#f15353`;

  const btnList = document.querySelectorAll(".wp-block-button");

  if (btnList.length > 0) {
    btnList.forEach((btn) => {
      const link = btn.querySelector(".wp-block-button__link");
      color = link.classList.contains("has-colore-tema-4-color") ? `#FFFFFF` : `#f15353`;

      const svg = `
        <svg id="Livello_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 205 60">
            <g id="Raggruppa_67">
                <g id="Raggruppa_33">
                    <path id="Tracciato_13" class="st0" fill="none" stroke="${color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px" d="M163.9,41c-15.6,12.1-61.7,17-83.6,16.9M80.3,57.9c-17.4-.1-35.6-1-50.2-4.2C4.9,48.2-1.4,36.9,4.6,28c2.4-3.4,5.6-6.1,9.3-8,9.1-4.9,22.7-8.9,37.7-12,11.1-2.3,22.3-3.9,33.6-4.8,18.6-1.4,37.2-1.4,55.8,0,17.4,1.3,33.8,4.2,45,8.6,17.7,6.7,21.4,16.3,9.5,24.1-6.5,4.5-15.4,7.7-29,10.2,0,0-63.6,10.5-119.3,4.9C-8.5,45.3-18.4,2.1,130.9,2.5"/>
                </g>
            </g>
        </svg>`;

      btn.insertAdjacentHTML("afterbegin", svg);

      const svgElement = btn.querySelector("svg");
      const path = svgElement.querySelector("path");

      // Init the path to be hidden
      gsap.set(path, {
        drawSVG: "100%",
      });

      btn.addEventListener("mouseenter", () => {
        gsap.fromTo(
          path,
          {
            drawSVG: "0%",
          },
          {
            drawSVG: "100%",
            duration: 1,
            ease: "none",
          }
        );
      });
    });
  }

  const formSubmit = document.querySelector(".wpcf7-submit-wrapper");
  if (formSubmit) {
    color = `#f15353`;

    const formSvg = `
        <svg id="Livello_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 205 60">
            <g id="Raggruppa_67">
                <g id="Raggruppa_33">
                    <path id="Tracciato_13" class="st0" fill="none" stroke="${color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px" d="M163.9,41c-15.6,12.1-61.7,17-83.6,16.9M80.3,57.9c-17.4-.1-35.6-1-50.2-4.2C4.9,48.2-1.4,36.9,4.6,28c2.4-3.4,5.6-6.1,9.3-8,9.1-4.9,22.7-8.9,37.7-12,11.1-2.3,22.3-3.9,33.6-4.8,18.6-1.4,37.2-1.4,55.8,0,17.4,1.3,33.8,4.2,45,8.6,17.7,6.7,21.4,16.3,9.5,24.1-6.5,4.5-15.4,7.7-29,10.2,0,0-63.6,10.5-119.3,4.9C-8.5,45.3-18.4,2.1,130.9,2.5"/>
                </g>
            </g>
        </svg>`;

    formSubmit.insertAdjacentHTML("afterbegin", formSvg);

    const svgElement = formSubmit.querySelector("svg");
    const path = svgElement.querySelector("path");

    // Init the path to be hidden
    gsap.set(path, {
      drawSVG: "100%",
    });

    formSubmit.addEventListener("mouseenter", () => {
      gsap.fromTo(
        path,
        {
          drawSVG: "0%",
        },
        {
          drawSVG: "100%",
          duration: 1,
          ease: "none",
        }
      );
    });
  }
};

export default btns;
